/* eslint-disable no-useless-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, {
  useContext,
  createContext,
  useState,
  useCallback,
  useEffect,
} from 'react';

import { api } from '../../services';
import { useLoadingContext } from '../use-loading';
import {
  getStorege,
  removeStorege,
  saveStorege,
} from '../../helpers/db_storage';

interface IparamLogin {
  user_name: string;
  user_password: string;
  dsTipo: string;
}

interface iParamsSigningOut {
  http_status?: number;
  location?: string;
  id_shop?: string;
}

interface iResult {
  status: number;
  data: {
    mensagem: any;
    retorno: any;
    retornoTipo: string;
    flgCadastraTelefone: number;
    token: string;
  };
}

interface IUser {
  idUsuario: number;
  dsNome: string;
  dsSenha: string;
  dsEmail: string;
}

type IData = {
  message?: {
    user?: IUser | any;
  };
  user?: IUser | any;
  return?: any;
  returnType?: string;
  registerPhone?: number;
  signedLoading?: boolean;
  msgError?: string;
  statusCode?: number;
};

type ISignInContext = {
  data: IData;
  signed: boolean;
  signing(paramLogin: IparamLogin): Promise<void>;
  signingSaveLocal(dataUser: any): Promise<void>;
  signingGoogle(code: string): Promise<void>;
  getDataUser(id_person: IUser | any, save_data?: boolean): Promise<void>;
  signingOut(params: iParamsSigningOut): Promise<void>;
  cleanData(): Promise<void>;
};
const SignInContext = createContext<Partial<ISignInContext>>({});

export const UserSignInProvider = ({ children }: any) => {
  const { createloading } = useLoadingContext();

  const [data, setData] = useState<IData>({
    signedLoading: false,
    message: {
      user: null,
    },
    return: '',
    returnType: '',
    registerPhone: 0,
    user: null,
    msgError: '',
    statusCode: 0,
  });

  const dataUserMemory = useCallback(() => {
    return new Promise((resolve) => {
      const dataUserStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/user') as string,
      );

      if (dataUserStorage) {
        setData({
          user: dataUserStorage,
        });
      }
      resolve(true);
    });
  }, []);

  useEffect(() => {
    (async () => {
      await dataUserMemory();
    })();
  }, []);

  const signing = async (paramLogin: IparamLogin) => {
    try {
      createloading(true);

      const userData = await api.apiMaisdelivery.auth.signIn<iResult>({
        nr_operacao: paramLogin.dsTipo === 'email' ? 7 : 45,
        ...paramLogin,
      });

      setData({
        user: userData.data,
        return: userData.data.retorno,
        msgError: '',
      });

      if (userData.data.retorno === 'OK') {
        localStorage.setItem(
          '@mais/delivery/authorization',
          JSON.stringify(userData.data.token),
        );
        localStorage.setItem(
          '@mais/delivery/user',
          JSON.stringify(userData.data),
        );
      }
      createloading(false);
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setData({
          msgError: error.response.data.message,
        });
        createloading(false);
        return;
      }
      setData({
        msgError: 'Ocorreu algum erro, tente novamente mais tarde.',
      });
      createloading(false);
    }
  };

  const signingSaveLocal = async (dataUser: any) => {
    try {
      createloading(true);

      setData({
        user: dataUser,
        return: dataUser.retorno,
        msgError: dataUser.mensagem,
      });

      createloading(false);

      if (dataUser.retorno === 'OK') {
        localStorage.setItem(
          '@mais/delivery/authorization',
          JSON.stringify(dataUser.token),
        );
        localStorage.setItem('@mais/delivery/user', JSON.stringify(dataUser));

        removeStorege('@mais/delivery/user/create');
      }
    } catch (error: any) {
      setData({
        msgError: 'Ocorreu algum erro, tente novamente mais tarde.',
      });
      createloading(false);
    }
  };

  const signingGoogle = async (code: string) => {
    try {
      createloading(true);

      const userData = await api.apiMaisdelivery.auth.signIn<iResult>({
        nr_operacao: 73,
        code,
      });

      setData({
        user: userData.data,
        return: userData.data.retorno,
        returnType: userData.data.retornoTipo,
        msgError: userData.data.mensagem,
      });

      createloading(false);

      if (userData.data?.retornoTipo === 'C') {
        setData({
          user: null,
          return: '',
          returnType: userData.data.retornoTipo,
          msgError: userData.data.mensagem,
        });
        saveStorege('@mais/delivery/user/create', userData.data);

        return;
      }

      setData({
        user: userData.data,
        return: userData.data.retorno,
        returnType: userData.data.retornoTipo,
        msgError: userData.data.mensagem,
      });

      if (userData.data.retorno === 'OK') {
        localStorage.setItem(
          '@mais/delivery/authorization',
          JSON.stringify(userData.data.token),
        );
        localStorage.setItem(
          '@mais/delivery/user',
          JSON.stringify(userData.data),
        );
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setData({
          msgError: error.response.data.message,
        });
        createloading(false);
        return;
      }
      setData({
        msgError: 'Ocorreu algum erro, tente novamente mais tarde.',
      });
      createloading(false);
    }
  };

  const signingOut = async (params: iParamsSigningOut) => {
    setData({ user: null });
    localStorage.setItem(
      '@mais/delivery/authorization',
      null as unknown as string,
    );
    localStorage.setItem('@mais/delivery/user', null as unknown as string);

    if (params?.http_status === 401) {
      if (params.location === 'requestDetail') {
        window.location.replace(
          `/pwa/sign/in/${window.btoa('requestProgress')}/${params.id_shop}`,
        );
        return;
      }
      window.location.replace('/pwa/sign/in');
      return;
    }
  };

  const getDataUser = async (id_user: number, save_data = true) => {
    try {
      const getData: any = await api.apiMaisdelivery.auth.getDataUser<iResult>({
        nr_operacao: 15,
        idUsuario: id_user,
      });

      if (save_data) {
        setData({
          user: getData?.data[0],
          return: getData.data.retorno,
        });
      }

      localStorage.setItem(
        '@mais/delivery/user',
        JSON.stringify(getData?.data[0]),
      );
    } catch (error: any) {
      setData({
        signedLoading: false,
        msgError: error,
      });
    }
  };

  const cleanData = async () => {
    setData({
      user: '',
      return: '',
      returnType: '',
      msgError: '',
    });
  };

  return (
    <SignInContext.Provider
      value={{
        data,
        cleanData,
        signing,
        signingSaveLocal,
        signingGoogle,
        getDataUser,
        signed: !!data?.user,
        signingOut,
      }}
    >
      {children}
    </SignInContext.Provider>
  );
};

export const useSignInContext: any = () => {
  return useContext(SignInContext);
};

export const getToken: any = () => {
  let token = localStorage.getItem('@mais/delivery/authorization');

  if (!token || token === 'null') {
    token = JSON.stringify(
      getStorege('@mais/delivery/authorization/orders')?.token,
    );
  }
  return token;
};
